/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Zurück',
      changePassword: 'Passwort ändern',
      copiedVaultId: 'Kopiert!',
      copyVaultID: 'Kopiere Vault ID',
      create: 'Erstellen',
      next: 'Weiter',
      notSure: 'Ich bin nicht sicher',
      signUp: 'Anmelden',
      submit: 'Einreichen',
      updatePassword: 'Passwort aktualisieren',
    },
    Errors: {
      createReportFailed: 'Erstellen der Meldung fehlgeschlagen.',
    },
    ReportStatus: {
      CLOSED: 'Geschlossen',
      INVESTIGATING: 'Wird untersucht',
      NEW: 'Eingereicht',
      READ: 'Gelesen',
    },
    general: {
      navbar: {
        caseSettings: 'Gehäuseeinstellungen',
        changePassword: 'Passwort ändern',
        logOut: 'Abmelden',
        notifications: 'Benachrichtigungen',
        notificationsDrawer: {
          appFileScanFailed:
            'Eine Datei hat die Sicherheitsprüfung nicht bestanden',
          appReportMatch: 'Ihr GoTogether Datensatz wurde übereingestimmt.',
          appReportReassigned: 'Ein neuer Fallmanager wurde zugewiesen',
          case: 'Fall',
          caseAssigned: 'Fall Ihnen zugewiesen',
          caseImporterJobCompleted: {
            PartialSuccess: 'Ihr Fallimport wurde mit Fehlern abgeschlossen',
            failure: 'Ihr Fallimport ist fehlgeschlagen',
            success: 'Ihr Fallimport wurde erfolgreich abgeschlossen',
          },
          caseLinked: 'Fall verknüpft',
          caseTeamInvite: 'Zum Fall hinzugefügt',
          caseUnlinked: 'Fall entkoppelt',
          dataSanitisation: 'Berichtsdetails aktualisiert',
          emptyDescription: 'Schauen Sie später nach neuen Benachrichtigungen',
          emptyTitle: 'Du bist auf dem neuesten Stand',
          importId: 'Import ID:',
          learnMore: 'Erfahren Sie mehr',
          markAllAsRead: 'Alle als gelesen markieren',
          newMessage: 'Neue Nachricht',
          newReport: 'Neuer Bericht erhalten',
          permissionRemoved: 'Aus dem Fall entfernt',
          postSSubmissionFile: 'Beweisdatei(en) hinzugefügt',
          report: 'Bericht',
          reportAssigned: 'Zugewiesener Bericht für Sie',
          reportStatusChange: 'Statusbericht geändert',
          reporterAnonymised: 'Ihre Daten wurden anonymisiert',
          reporterReportSubmitted: {
            subtitle: 'Wir empfehlen, eine Kopie Ihres Berichts zu speichern',
            title: 'Bericht eingereicht',
          },
          mitigationPlanReminder: 'Genehmigung des Maßnahmenplans erforderlich',
          staleCase: 'Nicht bearbeiteter Fall',
        },
        privacyStatement: 'Datenschutzerklärung',
        reporter: {
          myReports: 'Meine Berichte',
        },
        settings: 'Einstellungen',
        technicalSupport: 'Technischer Support',
        title: 'Konto',
      },
      time: {
        day: 'Tag',
        days: 'Tage',
        hour: 'Stunde',
        hours: 'Stunden',
        minute: 'Minute',
        minutes: 'Minuten',
        second: 'Sekunde',
        seconds: 'Sekunden',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonym',
        autoTranslate:
          'Die automatische Übersetzung ist standardmäßig deaktiviert.',
        backToMessages: 'Zurück zu Nachrichten',
        caseSettings: 'Einstellungen zum Fall.',
        changeInProfile:
          'Wenn Sie diese Einstellung ändern möchten, können Sie dies in Ihrem Profil tun.',
        deletedByMessage: 'Gelöscht von {{author}}',
        deletedMessageLabel: 'Diese Nachricht wurde gelöscht',
        description:
          'Wenn die automatische Übersetzung aktiviert ist, werden alle Berichtsnachrichten automatisch übersetzt, indem KI auf der Grundlage der in Ihrem Browser ausgewählten Standardsprache verwendet wird.',
        descriptionSecondHalf:
          'Die ursprüngliche Version aller Nachrichten wird immer aufbewahrt und kann im Chat gefunden werden.',
        messagePlaceholder: 'Beginnen Sie zu tippen...',
        messageSettings: 'Nachrichteneinstellungen.',
        originalMessages: 'Original',
        showMoreBanner: 'Erfahren Sie mehr über automatische Übersetzungen',
        titlev2: 'Lesen Sie alle Nachrichten in Ihrer bevorzugten Sprache.',
        translatedMessageLabel: 'Übersetzte Nachricht',
        translatedMessages: 'Übersetzt',
        understood: 'Verstanden',
      },
      Country: {
        description: 'In welchem Land sind Sie tätig?',
        header: 'In welchem Land sind Sie tätig?',
        noOptions: 'Keine Länder gefunden',
        other: 'Andere',
        placeholder: 'Land suchen...',
      },
      CreatePublicReport: {
        createReport: 'Neue Meldung erstellen',
        helpPage: 'Gehe zu unserer Hilfeseite',
        loginToOpr: 'Anmeldung zum Verfolgen von Berichten',
        or: 'oder',
        passwordPlaceholder: 'Passwort eingeben',
        phoneNumberLoginFailed:
          'Anmeldung fehlgeschlagen, Telefonnummer/PIN inkorrekt',
        phoneNumberPlaceholder: 'Geben Sie Ihre Telefonnummer ein',
        phoneNumberTooltip:
          'Geben Sie die Telefonnummer ein, die Sie verwendet haben, um VaultTalk zu kontaktieren.',
        pinPlaceholder: 'PIN eingeben',
        reportIntroductionParagraph1:
          'Wenn Sie einen Vorfall melden, werden Ihnen einige Fragen gestellt, um Sie bei der Dokumentation Ihrer Erfahrung zu unterstützen.',
        reportIntroductionParagraph2:
          'Bevor Sie absenden, haben Sie die Möglichkeit, anonym zu bleiben, um Ihre Privatsphäre zu schützen.',
        reportIntroductionParagraph3:
          'Nachdem Sie Ihre Angaben eingereicht haben, können Sie sich jederzeit einloggen, um den Fortschritt Ihres Berichts zu sehen und mit einem Fallmanager zu sprechen.',
        reportIssue: 'Problem melden',
        usernameLoginFailed:
          'Anmeldung fehlgeschlagen, Benutzername/Passwort inkorrekt',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Die Beziehung zum Unternehmen ist erforderlich',
            reportedCategoryRequired:
              'Die gemeldete Kategorie ist erforderlich',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Geben Sie Ihre E-Mail oder Vault ID ein',
        vaultIdTooltip:
          'Für anonyme Berichte ist die Vault-ID alphanumerisch. Wenn der Bericht nicht anonym war, ist die Vault-ID Ihre E-Mail-Adresse.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Ihr Passwort',
        yourPhoneNumber: 'Ihre Telefonnummer',
        yourPin: 'Ihre 6-stellige PIN',
        yourVaultId: 'Ihre Vault-ID',
      },
      CustomHeader: {
        companyLogo: 'Firmenlogo',
        openReporting: 'Reporting öffnen',
        userSettings: 'Benutzereinstellungen',
      },
      Date: {
        approximateDescription:
          'Erinnern Sie sich an das ungefähre Datum, an dem der Vorfall stattgefunden hat?',
        approximatePlaceholder:
          'Beispiel: vor 6 Monaten / letztes Jahr / letzten November',
        cancel: 'abbrechen',
        clear: 'löschen',
        description:
          'Erinnern Sie sich an das Datum, an dem der Vorfall stattgefunden hat?',
        header: 'An welchem Tag fand der Vorfall statt?',
        ok: 'ok',
        placeholder: 'Beispie: 21. Juni 2020',
      },
      Description: {
        whatHappened: 'Was ist vorgefallen?',
        whatHappenedPlaceholder: 'Verwenden Sie Ihre eigenen Worte...',
        whatHappenedText:
          'Beschreiben Sie in Ihren Worten, was vorgefallen ist.',
      },
      Details: {
        disclaimer:
          'Diese Details werden mit Ihrer Meldung offengelegt. Wenn Sie anonym bleiben möchten, stellen Sie sicher, dass sie keine identifizierenden Informationen enthalten.',
        emailPlaceholder: 'E-Mail-Adresse (optional)',
        fullNamePlaceholder: 'Vollständiger Name (optional)',
        header: 'Ihre Daten',
        nonAnonSubtitle:
          'Bitte geben Sie entweder Ihren Namen oder eine E-Mail-Adresse an. Wenn Sie Benachrichtigungen über diesen Bericht erhalten möchten, fügen Sie unten eine geeignete E-Mail-Adresse hinzu.',
        nonOptionalEmailPlaceholder: 'E-Mail',
        nonOptionalFullNamePlaceholder: 'Vollständiger Name',
        subtitle:
          'Wenn Sie Benachrichtigungen zu diesem Bericht erhalten möchten, fügen Sie unten eine entsprechende E-Mail-Adresse hinzu.',
      },
      Emotion: {
        description:
          'Wie haben Sie sich dabei gefühlt? Welche Auswirkung hatte das?',
        header: 'Welche Auswirkung hatte das?',
        placeholder: 'Geben Sie zuerst ein...',
      },
      Evidence: {
        addedHeading: 'Hinzugefügt',
        deletedMessage: 'wurde gelöscht',
        deletedStatus: 'Gelöscht',
        failedToOpenFileMessage:
          'Fehler beim Öffnen der Datei. Bitte versuchen Sie es erneut.',
        fileStatuses: {
          infectedUpload: 'Durch Sicherheitskontrolle markiert',
          passedUpload: 'Bestandene Sicherheitsprüfung',
          pendingUpload: 'Sicherheitsüberprüfung läuft',
          readyForDownload: 'Bereit zum Herunterladen',
        },
        mobileErrorMessage:
          'Gekennzeichnete Dateien: Nachricht an Ihren Fallmanager',
        nameHeading: 'Name',
        statusHeading: 'Status',
        tableTitle: 'Beweis',
        webErrorMessage:
          'Markierte Dateien: Wenn Ihre Datei(en) markiert wurde(n), bitte schicken Sie eine Nachricht an den Fallmanager.',
      },
      FileUpload: {
        addFiles: 'Dateien hinzufügen',
        addMoreFiles: 'Füge mehr Dateien hinzu',
        confirm: 'Bestätigen',
        description:
          'Das Hinzufügen von Dateien als Beweise kann die Effizienz der Lösung durch Ihren Fallmanager unterstützen. Bitte berücksichtigen Sie den Dateiinhalt (einschließlich der Dateimetadaten), wenn Sie anonym bleiben möchten, und respektieren Sie die Rechte anderer Personen und geltende Gesetze.',
        dragDrop: 'Dateien hier ablegen oder',
        errorMessage:
          'Datei(en) aufgrund eines Netzwerkfehlers gescheitert. Klicken Sie unten, um Ihrem Fallmanager eine Nachricht zur Unterstützung zu senden.',
        fileLimit: 'Dateigrößenlimit für jede Datei: 100MB',
        fileUploadLimitText: 'Sie können nur 10 Dateien hochladen',
        header: 'Beweise hinzufügen',
        helpArticle: 'Hilfeartikel',
        highlighted: 'Dateien durchsuchen',
        information: 'Unterstützte Dateitypen',
        moreInformation:
          'Für weitere Informationen, sehen Sie bitte dies <a>Hilfeartikel</a>',
        postSubmissionErrorMessage:
          "Wir konnten Ihre Dateien aufgrund eines Systemfehlers nicht hochladen. Bitte wählen Sie 'bestätigen' erneut aus.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumente:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Bilder:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Text:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Die Datei ist zu groß',
          invalidFileType: 'Nicht unterstützter Dateityp: {{Erweiterung}}',
          systemError: 'Systemfehler',
          tooManyFiles: 'Maximale Anzahl an Dateien ist {{maxFiles}}',
        },
        uploadFiles: 'Dateien hochladen',
      },
      Loading: {
        loading:
          'Bitte warten Sie, während wir Ihren Bericht an einen Fallmanager weiterleiten...',
        postSubmissionLoading:
          'Bitte warten Sie, während wir Ihre Datei(en) übermitteln...',
      },
      Location: {
        description: 'Wo ist das vorgefallen?',
        header: 'Wo ist das vorgefallen?',
        placeholder: 'Beispiel: Im Büro',
      },
      MessageListBox: {
        messageCaseManager: 'Nachricht Fall-Manager',
        report: 'Meldung {{displayReportId}}{{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Übersetzung deaktiviert',
        enableTranslationLabelEnabled: 'Übersetzung aktiviert',
        enableTranslationsDescription:
          'Aktivieren Sie automatische Übersetzungen und lesen Sie alle Berichtsnachrichten in Ihrer bevorzugten Sprache. Die übersetzte Sprache basiert auf der Sprache, die auf Ihrem Gerät ausgewählt wurde.',
        enableTranslationsHeader:
          'Aktivieren Sie automatische Übersetzungen für Berichtsnachrichten',
        enableTranslationsSubDescriptionv2:
          'Sie können in jedem Chat zwischen der übersetzten und der Originalsprache wechseln.',
        updateTranslationFailed:
          'Aktualisierung der Übersetzung fehlgeschlagen',
        updateTranslationSuccess:
          'Übersetzungseinstellung erfolgreich aktualisiert',
      },
      Password: {
        changePasswordHeader: 'Passwort ändern',
        createNewPassword: 'Bitte geben Sie ein neues Passwort ein',
        createPasswordHeader: 'Ihr Passwort',
        currentPasswordPlaceholder: 'Aktuelles Passwort eingeben',
        description:
          'Ein gültiges Passwort muss mindestens 9 Zeichen lang sein und einen Großbuchstaben sowie eine Zahl enthalten.',
        enterCurrentPassword: 'Bitte geben Sie Ihr aktuelles Passwort ein.',
        forgottenPasswordInstructions:
          'Geben Sie Ihre alphanumerische Vault-ID (nicht Ihre E-Mail-Adresse) und E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.',
        newDescription:
          'Erstellen Sie ein starkes Passwort, um Ihr Konto sicher zu halten. Beginnen Sie mit der Eingabe, um die Richtlinien unten zu sehen.',
        passwordPlaceholder: 'Passwort erstellen',
        passwordResetRequestedDescription:
          'Wenn Ihre Vault-ID in unserem System vorhanden ist, erhalten Sie eine E-Mail mit Anweisungen zur Zurücksetzung Ihres Passworts.',
        passwordResetRequestedHeader:
          'Link zur Zurücksetzung des Passworts angefordert',
        reenterPlaceholder: 'Passwort erneut eingeben',
        subtitle:
          'Erstellen Sie ein Passwort, um diesen Bericht einzureichen und in Zukunft darauf zuzugreifen',
        yourVaultId: 'Ihre Vault-ID',
        yourVaultIdPlaceholder:
          'Geben Sie Ihre Vault ID ein (z.B. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Melden Sie eine bestimmte Person oder mehrere Personen? Können Sie sie benennen oder beschreiben?',
        header: 'Beteiligte Personen',
        placeholder:
          'Beginnen Sie mit der Eingabe und verwenden Sie ein Komma, um mehrere Namen oder Beschreibungen hinzuzufügen.',
      },
      PoweredByVault: 'Von {{company}}',
      PrivacyStatement: 'Datenschutzerklärung für Produkte',
      PublicMessageList: {
        myMessages: 'Meine Nachrichten',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Beweise zu bestehendem Bericht hinzugefügt',
        backToReportId: 'Zurück zum Bericht ID: {{reportId}}',
        description:
          'Das Hinzufügen von Dateien als Beweismittel kann die Effizienz der Lösungsfindung durch Ihren Fallmanager unterstützen. Bitte beachten Sie den Dateiinhalt (einschließlich Datei-Metadaten), wenn Sie anonym bleiben möchten, und respektieren Sie die Rechte anderer Personen und geltende Gesetze. Für weitere Informationen, bitte sehen Sie dies an. <a>Hilfeartikel</a>',
        header: 'Fügen Sie zusätzliche Beweise zum Bericht hinzu',
        vaultTalkOpenCaseHeader: 'Fügen Sie Beweise zu Ihrem Bericht hinzu',
      },
      PublicReport: {
        anonymous: 'Anonym',
        backToReports: 'Zurück zu Meldungen',
        skipped: 'Übersprungen',
      },
      PublicReportCard: {
        addEvidence: 'Fügen Sie zusätzliche Beweise hinzu',
        messageCaseManager: 'Nachricht Fall-Manager',
        reportId: 'Melde-ID: ',
        submitted: 'Eingereicht',
        vaultTalkClosedCaseCTA: 'Beweise anzeigen',
        vaultTalkOpenCaseCTA: 'Fügen Sie Beweise hinzu',
        viewAdditionalEvidence: 'Zusätzliche Beweise anzeigen',
        viewReport: 'Meldung anzeigen',
      },
      PublicReportsList: {
        reportingSystem: 'Meldesystem',
      },
      Question: {
        placeholder: 'Beginnen Sie zu tippen...',
        question: 'Geben Sie Details an',
        questionText:
          'Bitte teilen Sie uns Ihr Anliegen, Update oder Ihre Anfrage mit.',
      },
      Relationship: {
        header: 'Ihre Beziehung zur Organisation',
        tellUsAbout:
          'Bitte erzählen Sie uns etwas über Ihre Beziehung zur Organisation.',
      },
      ResponsiveNavMenu: {
        messages: 'Meine Nachrichten',
        reports: 'Meine Berichte',
      },
      Site: {
        description: 'An welchem Standort sind Sie tätig?',
        header: 'An welchem Standort sind Sie tätig?',
        noOptions: 'Keine Standorte gefunden',
        other: 'Andere',
        placeholder: 'Standort suchen...',
      },
      SpamPuzzle: {
        dialog: 'Um fortzufahren, lösen Sie bitte dieses Rätsel.',
      },
      SubmissionTypes: {
        reportIssue: 'Wählen Sie eine Kategorie',
        whatType:
          'Wählen Sie die Kategorie, die Ihren Bericht am besten beschreibt',
      },
      SubmitSuccess: {
        category: '<bold>Kategorie:</bold> {{category}}',
        country: '<bold>Land:</bold> {{country}}',
        dateSubmitted: '<bold>Eingereichtes Datum:</bold> {{date}}',
        recordYourVaultID:
          'Merken Sie sich diese Informationen für die Anmeldung',
        successInformation: 'Mehr Informationen',
        successMessage:
          'Ihr Bericht wurde eingereicht und ist zur Überprüfung bereit. Alle angehängten Dateien, die Aufmerksamkeit erfordern, werden beim Anmelden markiert. Melden Sie sich unten an, um Berichtsaktualisierungen einzusehen und Ihrem Fallmanager eine Nachricht zu senden.',
        successSanitationMessage:
          'Bewahren Sie eine Kopie für Ihre Unterlagen auf und bewahren Sie Ihre Vault-ID sicher auf - Sie benötigen sie, um Updates abzurufen und Ihrem Fallmanager eine Nachricht zu senden.',
        successSanitationTagline:
          'Ihr Bericht wurde eingereicht und sicher gespeichert.',
        successThankYou: 'Vielen Dank für Ihren Bericht!',
        viewReport: 'Bericht anzeigen',
      },
      Time: {
        approximateDescription:
          'Erinnern Sie sich an die ungefähre Uhrzeit, zu der dieser Vorfall stattgefunden hat?',
        approximatePlaceholder: 'Beispiel: morgens, nachmittags',
        description:
          'Erinnern Sie sich an die Uhrzeit, zu der dieser Vorfall stattgefunden hat?',
        header: 'Zu welcher Uhrzeit ist das vorgefallen?',
        invalidTime: 'Zeitformat muss HH:MM sein',
      },
      UserSettingsDialog: {
        changePassword: 'Passwort ändern',
        closeDialog: 'Fenster schließen',
        logout: 'Abmelden',
        messageSettings: 'Nachrichteneinstellungen',
        userSettings: 'Benutzereinstellungen',
      },
      Witnesses: {
        description:
          'Haben Sie jemand anderem davon erzählt oder hat jemand gesehen, was vorgefallen ist?',
        header: 'Gab es Zeugen?',
        placeholder: 'Geben Sie zuerst ein...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Nachricht senden',
        title: 'Nachrichten Fallmanager',
        translationHeader: 'Erfahren Sie mehr über automatische Übersetzungen',
      },
      ReportCard: {
        addEvidence: 'Fügen Sie Beweise hinzu',
        submissionModeVia: 'über {{submissionMode}}',
        viewEvidence: 'Beweise betrachten',
      },
      ReportList: {
        yourReports: 'Ihre Berichte',
      },
      ReportingActivate: {
        buttonText: 'Fahren Sie fort',
        description:
          'Wenn Ihre Organisation Sie für ein Konto registriert hat, senden wir Ihnen eine E-Mail mit Anweisungen zur Vervollständigung der Einrichtung.',
        emailInput: 'E-Mail',
        header: 'Geben Sie Ihre berufliche E-Mail ein',
        successAccount:
          'Wenn Ihre Organisation Sie für ein Konto registriert hat, senden wir Ihnen eine E-Mail mit Anweisungen zur Vervollständigung der Einrichtung.',
        successEmail:
          'Wenn Sie es nicht sofort sehen, warten Sie bitte ein paar Minuten und aktualisieren Sie Ihren E-Mail-Posteingang.',
        successHeading: 'Danke',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Fügen Sie Beweise zu Ihrem Bericht hinzu',
        descriptionText:
          'Das Hinzufügen von Dateien als Beweise kann die Effizienz der Bearbeitung durch Ihren Fallmanager unterstützen. Bitte berücksichtigen Sie den Dateiinhalt (einschließlich der Dateimetadaten), wenn Sie anonym bleiben möchten, und respektieren Sie die Rechte anderer Personen und geltende Gesetze. Für weitere Informationen sehen Sie bitte diesen <a>Hilfe-Artikel</a> an.',
        emptyMessage: 'Keine weiteren Beweise hochgeladen',
      },
      ReportingChangePassword: {
        back: 'Zurück',
        description:
          'Erstellen Sie ein starkes Passwort, um Ihr Konto sicher zu halten. Beginnen Sie mit der Eingabe, um die Richtlinien unten zu sehen.',
        errorToast: 'Passwort kann nicht erstellt werden, ungültiges Token.',
        header: 'Passwort ändern',
        incorrectCurrentPassword:
          'Das aktuelle Passwort ist falsch. Bitte überprüfen Sie es und versuchen Sie es erneut.',
        invalidToken: 'Ungültiges Token',
        passwordUpdated: 'Passwort aktualisiert',
        passwordUpdatedDescription:
          'Ihr Passwort wurde erfolgreich aktualisiert. Vielen Dank, dass Sie diesen Schritt unternommen haben, um Ihre Daten sicher zu halten!',
        passwordUsedBefore: 'Wiederverwendung von Passwörtern nicht erlaubt',
        passwordUsedBeforeDescription:
          'Zu Ihrer Sicherheit können Sie keines Ihrer letzten sechs Passwörter erneut verwenden. Bitte wählen Sie ein neues, einzigartiges Passwort, um Ihr Konto sicher zu halten und versuchen Sie es erneut.',
        toastDescription:
          'Ihr Passwort wurde erfolgreich aktualisiert. Vielen Dank, dass Sie diesen Schritt unternommen haben, um Ihre Daten sicher zu halten!',
        toastMessage: 'Passwort aktualisiert',
        updatePasswordCTA: 'Passwort aktualisieren',
      },
      ReportingConnect: {
        cancelButton: 'Abbrechen',
        connectButton: 'Verbinden',
        disclaimer:
          'Das Verbinden Ihres Slack-Kontos mit Ihrem Vault-Konto stellt eine sichere und private Verbindung sicher.<br /><br />Durch die Verbindung können Sie Fehlverhalten melden oder direkt innerhalb von Slack eine Frage stellen. Sie haben nach dem Verbinden immer die Möglichkeit, anonym zu berichten. Ihre Privatsphäre und Sicherheit sind unsere obersten Prioritäten.',
        heading:
          'Vault Platform beantragt die Erlaubnis, auf Ihr {{organisationName}} Slack-Konto zuzugreifen',
        listHeading: 'Was wird Vault in der Lage sein zu tun?',
        permissionIdentity: {
          extraInfo:
            'Vault wird in der Lage sein, die Identität Ihres Slack-Benutzers einzusehen.',
          heading: 'Informationen über die Identität eines Benutzers anzeigen',
        },
        permissionNotifications: {
          extraInfo:
            'Vault kann Ihnen Benachrichtigungen zu Ihrem Slack-Konto senden, bezüglich aller Aktualisierungen zu einem bereits eingereichten Bericht oder Fragen.',
          heading: 'Senden Sie Ihnen Benachrichtigungen',
        },
        permissionOverview: {
          extraInfo:
            'Vault wird eine Übersicht aller Einreichungen auf der Startseite anzeigen.',
          heading: 'Übersicht der Einreichungen',
        },
        permissionSubmitReport: {
          extraInfo:
            'Dies wird Vault die Berechtigung erteilen, einen Bericht einzureichen oder eine Frage direkt an Ihre Organisation über Slack zu stellen.',
          heading:
            'Reichen Sie einen Bericht oder eine Frage in Ihrem Namen ein',
        },
        successfulConnectionDescription:
          'Ihr Vault-Konto und Ihr Slack-Konto sind jetzt verbunden. Sie können diesen Tab jetzt schließen und zu Slack zurückkehren.',
        successfulConnectionHeading: 'Erfolgreich verbunden',
        unsuccessfulConnectionDescription:
          'Etwas ist schief gelaufen. Bitte schließen Sie diesen Tab und kehren Sie zu Slack zurück, um es erneut zu versuchen.',
        unsuccessfulConnectionHeading: 'Verbindung fehlgeschlagen',
      },
      ReportingForgotPassword: {
        description:
          'Geben Sie die E-Mail-Adresse ein, die mit Ihrem Konto verknüpft ist, und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
        heading: 'Vergessenes Passwort',
        invalidTokenError: 'Kann kein Passwort erstellen, ungültiger Token.',
        passwordReuseError: 'Wiederverwendung des Passworts nicht erlaubt',
        passwordReuseErrorDescription:
          'Zu Ihrer Sicherheit können Sie keines Ihrer letzten sechs Passwörter erneut verwenden. Bitte wählen Sie ein neues, einzigartiges Passwort, um Ihr Konto sicher zu halten und versuchen Sie es erneut.',
        sendLink: 'Link zum Zurücksetzen senden',
        sendLinkFailure: 'Etwas ist schief gelaufen',
        sendLinkFailureDescription:
          'Gehen Sie zurück zum <a>Reporter Hub</a> und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns unter <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link zum Zurücksetzen des Passworts gesendet',
        sendLinkSuccessDescription:
          'Wir haben einen Link zum Zurücksetzen des Passworts an {{Email}} gesendet.',
        updatePasswordSuccess: 'Passwort aktualisiert',
        updatePasswordSuccessDescription:
          'Ihr Passwort wurde erfolgreich aktualisiert. Vielen Dank, dass Sie diesen Schritt unternommen haben, um Ihre Daten sicher zu halten!',
      },
      ReportingLogin: {
        accountFrozen: 'Konto ist eingefroren',
        accountLocked:
          'Die Anmeldung wurde zu oft falsch versucht. Das Konto ist für bis zu 1 Stunde gesperrt. Während dieser Zeit ist eine Passwortzurücksetzung nicht möglich.',
        accountLockedPermanently:
          'Ihr Konto wurde gesperrt. Verwenden Sie die Passwortzurücksetzung, um wieder Zugang zu erhalten, oder wenden Sie sich für weitere Hilfe an Ihren Systemadministrator.',
        createAccountCTA: 'Registrieren Sie sich für ein Konto',
        currentPassword: 'Aktuelles Passwort',
        emailLabel: 'Ihre E-Mail',
        forgotPassword: 'Passwort vergessen?',
        loginButton: 'Anmeldung',
        newPasswordPlaceholder: 'Neues Passwort',
        passwordFailMessage:
          'Kehren Sie zurück zur Vault App in Slack und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an uns unter techsupport@vaultplatform.com',
        passwordFailTitle: 'Etwas ist schief gelaufen',
        passwordLabel: 'Ihr Passwort',
        passwordPlaceholder: 'Geben Sie Ihr Passwort ein',
        passwordResetRequired: 'Passwortzurücksetzung erforderlich',
        passwordSuccessfullySetMessage:
          'Kehren Sie zurück zur Vault App in Slack und authentifizieren Sie sich mit Ihrem neuen Passwort, um dort fortzufahren, wo Sie aufgehört haben.',
        passwordSuccessfullySetTitle: 'Passwort erfolgreich festgelegt',
        reenterPlaceholder: 'Passwort erneut eingeben',
        title: 'Reporter Hub',
        tooltip:
          'Wenn Sie noch nie ein Passwort für die Vault-App festgelegt haben, folgen Sie hier, um zu beginnen. Wenn Sie Ihr Passwort vergessen haben, verwenden Sie den Link "Passwort vergessen" unten.',
        usernameLoginFailed:
          'Login fehlgeschlagen, Benutzername oder Passwort falsch',
      },
      ReportingReset: {
        failureDescription:
          'Kehren Sie zur Vault App in Slack zurück und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns unter <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Etwas ist schief gelaufen',
        successDescription:
          'Kehren Sie zur Vault App in Slack zurück und authentifizieren Sie sich mit Ihrem neuen Passwort, um dort weiterzumachen, wo Sie aufgehört haben.',
        successHeading: 'Passwort erfolgreich gesetzt',
      },
      noReports: {
        description:
          'Alle eingereichten Berichte werden hier angezeigt. Erfahren Sie mehr über die Möglichkeiten, wie Sie einen Bericht einreichen können in',
        descriptionHelpArticle: 'dieser Hilfsartikel',
        errorDescription:
          'Wir haben Schwierigkeiten, Ihre Berichte zu laden. Bitte versuchen Sie, die Seite zu aktualisieren.',
        errorDescriptionSecondary:
          'Wenn das nicht funktioniert, kontaktieren Sie uns bitte unter',
        errorTitle: '⚠️ Hoppla, etwas ist schief gelaufen',
        title: 'Sie haben noch keine Berichte.',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Aktivieren Sie automatische Übersetzungen und lesen Sie alle Berichtsnachrichten in Ihrer bevorzugten Sprache. Die übersetzte Sprache basiert auf der auf Ihrem Gerät ausgewählten Sprache.',
          autoTranslationDescription2:
            'Sie können in jedem Chat zwischen der übersetzten und der Originalsprache wechseln.',
          autoTranslationTitle:
            'Aktivieren Sie automatische Übersetzungen für Berichtsnachrichten',
          header: 'Nachrichteneinstellungen',
          subHeader: 'Konfigurieren Sie, wie Nachrichten angezeigt werden',
        },
        notificationSettings: {
          emailDescription:
            'Erhalten Sie E-Mail-Benachrichtigungen für wichtige Aktualisierungen Ihrer Berichte',
          emailTitle: 'E-Mail-Benachrichtigungen',
          header: 'Benachrichtigungseinstellungen',
          subHeader: 'Konfigurieren Sie, wie Sie Benachrichtigungen erhalten',
        },
        title: 'Einstellungen',
        updatedSettingsFailure:
          'Die Aktualisierung Ihrer Einstellungen ist fehlgeschlagen',
        updatedSettingsSuccess:
          'Ihre Einstellungen wurden erfolgreich aktualisiert',
      },
    },
    validators: {
      passwordLength: 'Passwort muss mindestens 9 Zeichen lang sein',
      passwordLowercase: 'Passwort muss mindestens 1 Kleinbuchstaben enthalten',
      passwordMissMatch:
        'Die Passwort- und Bestätigung-Felder müssen übereinstimmen.',
      passwordNumeric: 'Passwort muss mindestens 1 Zahl enthalten',
      passwordUppercase: 'Passwort muss mindestens 1 Großbuchstaben enthalten',
    },
    validatorsNew: {
      passwordLength: 'Zwischen 10 und 30 Zeichen',
      passwordLowercase: 'Mindestens ein Kleinbuchstabe',
      passwordMissMatch: 'Passwörter stimmen nicht überein',
      passwordNumeric: 'Mindestens eine Zahl',
      passwordSpecialCharacter: 'Mindestens ein Sonderzeichen',
      passwordUppercase: 'Mindestens ein Großbuchstabe',
    },
  },
};

export default translations;
